import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RequestBodyConverter } from '../RequestBodyConverter';
import { useParams } from 'react-router-dom';
import ExclusiveOfferForm from './ExclusiveOfferForm';
// import { initialValues  } from './initialValues-testing';
import { showExclusiveOfferApi, updateExclusiveOfferApi, clearEditedExclusiveOffer } from './exclusiveOfferSlice';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';

function ExclusiveOfferUpdate() {
    const { id } = useParams();
    const [resetCount, setResetCount] = useState(0);
    const { editedModel: initialValues } = useSelector((state) => state.shopSaga.exclusiveOffer);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formSubmit = async (rawValues) => {
        let values = new RequestBodyConverter(rawValues);
        values = values.data;
        dispatch(clearApiValidationErrors()); //clear current api validation errors if any.
        dispatch(updateExclusiveOfferApi({ navigate, values, id }));
    };

    useEffect(() => {
        dispatch(showExclusiveOfferApi({ navigate, id }));

        return () => dispatch(clearEditedExclusiveOffer());
    }, []);

    return (
        <ExclusiveOfferForm
            resetCount={resetCount}
            setResetCount={setResetCount}
            pictureAttributeNames={['banner_image']}
            initialValues={initialValues}
            formSubmit={formSubmit}
        />
    );
}

export default ExclusiveOfferUpdate;
